import Vue from 'vue';
import { store } from '../../store/store';

Vue.mixin({
  methods: {
    copy(copyText) {
      const textarea = document.createElement('textarea');
      let result = false;
      textarea.value = copyText;
      textarea.style.display = false;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        result = document.execCommand('copy');
        if (result) {
          store.dispatch('alert/showToast', { type: 'success', message: this.$t('COPIED') });
        }
      } catch (e) {
        result = false;
      }
      textarea.remove();
      return result;
    },
  },
});
